
import isJson from 'helpers/isJson';
import fontsList from 'components/Templates/fontsList';
import oldDraftToTiptap from './oldDraftToTiptap';
import getContent from 'components/Templates/general/getContent';
import isDOM from 'helpers/isDOM';

function decodeHtmlEntities(html) {

  if (isDOM) {
    // Create a new div element
    const div = document.createElement('div');
    // Set the HTML content with the provided
    div.innerHTML = html;
    // Use `textContent` to get the decoded text
    return div.textContent || div.innerText || "";
  }

}

function decodeTextEntities(node) {
  if (Array.isArray(node)) {
    // If the node is an array, recursively call this function for each item
    return node.map(decodeTextEntities);
  } else if (node && typeof node === 'object') {
    // If the node is an object, decode its text if it has a text field, or recursively call this function for its content
    if (node.type === 'text' && typeof node.text === 'string') {
      // Decode the HTML entities in the text field
      node.text = decodeHtmlEntities(node.text);
    } else if (node.content) {
      // Recursively call this function for the content field
      node.content = decodeTextEntities(node.content);
    }
    return node;
  }
  // Return the node if it's neither an array nor an object
  return node;
}

export default function getTextContent(props, isCompare) {

  const {
    typeOfStyle,
    componentPayload,
    language,
    defaultValues,
    windowWidth,
    content,
    standalone
  } = props;

  const thisLanguage = language ? language : 'en';


  const thisContent = content ? content : componentPayload?.content && componentPayload.content[typeOfStyle] ? componentPayload.content : defaultValues;


  const getValue = getContent({
    typeOfStyle: typeOfStyle ? typeOfStyle : componentPayload?.typeOfStyle ? componentPayload.typeOfStyle : '',
    windowWidth: windowWidth,
    language: thisLanguage,
    content: thisContent,
    standalone: standalone
  });

  if (isCompare) return getValue && getValue.value ? getValue.value : null;


  const getStateValue = getValue && getValue.value ? isJson(getValue.value) : '';
  const getHtmlValue = getValue && getValue.value ? getValue.value : ''

  const rawInitalState = getStateValue 
    ? getStateValue 
    : getHtmlValue;

  const fontFamilies = fontsList.map((font) => {
    return { value: font.name, title: `${font.name}, ${font.fallback}` }
  });

  const initialEditorState = getStateValue ? getStateValue.type && getStateValue.type === 'doc' ? rawInitalState : oldDraftToTiptap(fontFamilies, rawInitalState) : rawInitalState;

  const decodedContent = getValue && getValue.value ? decodeHtmlEntities(getValue.value) : null;

  const decodedEditorState = decodeTextEntities(initialEditorState);


  return {
    editorState: decodedEditorState,
    content: decodedContent
  };

}
